import React from 'react';
import { Stack, Text } from '@moda/om';
import { Box } from '../../Box';
import { useOrderDetails } from '../../OrderDetails';

export const OrderDetailsShippingMethod: React.FC = () => {
  const { orderSummary } = useOrderDetails();

  if (!orderSummary) return null;

  const { shippingMethod } = orderSummary.attributes;

  return (
    <Stack space={3}>
      <Text family="serif" treatment="h5">
        Shipping Method
      </Text>
      <Box>
        <Text>{shippingMethod}</Text>
      </Box>
    </Stack>
  );
};
